export const SliceKeys = {
  organizationGrowthSlice: 'organizationGrowthSlice',
}
